
import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { submit as submitForm, change } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import FormControl from 'react-bootstrap/lib/FormControl';
import Button from 'react-bootstrap/lib/Button';
import { reduxForm } from 'redux-form';
import cx from 'classnames';

import DateRange from '../../Home/DateRange/DateRange';
import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';
import MobileDateRange from '../../Home/MobileDateRange/MobileDateRange';

import { changePersonalizedData } from '../../../actions/toggleControl';
import { getSpecificSettings } from '../../../actions/getSpecificSettings';
import { setPersonalizedValues } from '../../../actions/personalized';
import detectMobileBrowsers from '../../../helpers/detectMobileBrowsers';
import { searchFormSuggestSelect } from '../../../helpers/GeoSuggest/updateSearchForm';
import messages from '../../../locale/messages';
import searchLocation from '../../../helpers/searchLocation';

import bt from '../../commonStyle.css';
import s from './SearchForm.css';

class SearchForm extends React.Component {
  static propTypes = {
    setPersonalizedValues: PropTypes.any.isRequired,
    getSpecificSettings: PropTypes.any.isRequired,
    personalized: PropTypes.shape({
      location: PropTypes.string,
      lat: PropTypes.number,
      lng: PropTypes.number,
      chosen: PropTypes.number,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      personCapacity: PropTypes.number,
      formatMessage: PropTypes.any,
      isOneTotalToggle: PropTypes.bool,
    }),
    settingsData: PropTypes.shape({
      listSettings: PropTypes.array.isRequired
    }).isRequired
  };

  static defaultProps = {
    listingFields: []
  };

  static defaultProps = {
    personalized: {
      location: null,
      lat: null,
      lng: null,
      startDate: null,
      endDate: null,
      personCapacity: null,
      chosen: null
    },
    settingsData: {
      listSettings: []
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      mobileDevice: false,
      personCapacity: [],
      isLoad: false,
      smallDevice: false,
      isOneTotalToggle: false
    };
  }

  componentDidMount() {
    this.setState({ isLoad: false });
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields, personalized } = nextProps;
    const { setPersonalizedValues } = this.props;
    if (listingFields != undefined) {
      !personalized.personCapacity && setPersonalizedValues({ name: 'personCapacity', value: Number(listingFields?.personCapacity[0]?.startValue) });
      this.setState({
        personCapacity: listingFields.personCapacity
      });
    }
    if (personalized.isOneTotalToggle) this.setState({ isOneTotalToggle: personalized.isOneTotalToggle })
  }

  UNSAFE_componentWillMount() {
    const { listingFields, personalized } = this.props;
    if (listingFields != undefined) {
      this.setState({
        personCapacity: listingFields.personCapacity
      });
    }
    if (detectMobileBrowsers.isMobile() === true) {
      this.setState({ mobileDevice: true });
    }
    if (personalized.isOneTotalToggle) this.setState({ isOneTotalToggle: personalized.isOneTotalToggle })
  }

  componentWillUnmount() {
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  handleResize = (e) => {
    let isBrowser = typeof window !== 'undefined';
    let smallDevice = isBrowser ? window.matchMedia('(max-width: 767px)').matches : true;
    this.setState({ smallDevice });
  }

  handleClick = async () => {
    const { personalized, page, submitForm, setPersonalizedValues, change, changePersonalizedData } = this.props;
    let uri = '/s?';

    if (personalized?.searchLocationStatus) {
      searchLocation(setPersonalizedValues, personalized?.startDate, personalized?.endDate, change, personalized?.personCapacity, uri, personalized?.searchLocationStatus);
    } else {
      if (page != 'search' || (page == 'search' && (personalized?.chosen || personalized?.location))) {

        if (personalized?.chosen) {
          uri = uri + '&address=' + personalized?.location + '&chosen=' + personalized?.chosen;
        } else if (personalized?.location) {
          uri = uri + '&address=' + personalized?.location;
        }

        searchLocation(setPersonalizedValues, personalized?.startDate, personalized?.endDate, change, personalized?.personCapacity, uri);
      } else {
        if (personalized?.startDate && personalized?.endDate) {
          setPersonalizedValues({ name: 'isOneTotalToggle', value: true });
          change('SearchForm', 'isOneTotalToggle', true);
        }
        await changePersonalizedData('SearchForm', 'currentPage', 1);
        await submitForm('SearchForm');
        window.scrollTo({
          top: 0,
          left: 0
        });
      }
    }
  }

  formValue = (e) => {
    const { setPersonalizedValues, changePersonalizedData } = this.props;
    changePersonalizedData('SearchForm', 'personCapacity', e);
    setPersonalizedValues({ name: 'personCapacity', value: Number(e) })
  }

  onSuggestSelect = (data, value) => {
    const { setPersonalizedValues } = this.props;
    searchFormSuggestSelect({ data, setPersonalizedValues, value });
  }

  onChange = async (value) => {
    const { setPersonalizedValues, change } = this.props;
    if (value == '') {
      changeSearchForm({ setPersonalizedValues, change });
    }
  }

  render() {
    const { viewListingHeader, guests, personalized } = this.props;
    const { formatMessage } = this.props.intl;
    const { personCapacity, smallDevice } = this.state;
    let rows = [], guestCount = 1;
    if (personCapacity?.[0] && personCapacity[0]?.startValue) {
      for (let i = personCapacity[0]?.startValue; i <= personCapacity[0]?.endValue; i++) {
        rows.push(<option value={i} key={i}>{i} {i > 1 ? personCapacity[0]?.otherItemName : personCapacity[0]?.itemName}</option>);
      }
    }
    if (personalized?.personCapacity) {
      guestCount = personalized?.personCapacity;
    } else if (personCapacity?.[0] && personCapacity[0].startValue) {
      guestCount = personCapacity[0]?.startValue;
    }

    if (!personalized?.personCapacity && viewListingHeader == 'viewListingHeader') guestCount = guests;

    return (
      <div className={cx('searchHeaderForm')}>
        <div>
          <div className={cx(s.grid, 'searchHeaderPaddingRTL')}>
            <div className={cx(s.location, 'tableCellRTL', s.divider)}>
              <PlaceGeoSuggest
                placeholder={formatMessage(messages.homeWhere)}
                className={cx(s.formControlInput, s.input, 'searchPageHeaderForm')}
                initialValue={personalized?.location}
                onChange={this.onChange}
                onSuggestSelect={this.onSuggestSelect}
                id={'headerSearch'}
                containerClass='searchHeaderGeoSuggest'
              />
            </div>
            <div className={cx(s.dates, s.divider, s.dividerTop, 'dividerTopRTL')}>
              <span className={cx('homeDate', s.formControlInput, s.input, 'homeDateAR', 'headerSearchDate')}>
                {
                  !smallDevice && <DateRange  //search header
                    formName={'SearchForm'}
                    numberOfMonths={2}
                  />
                }

                {
                  smallDevice && <MobileDateRange
                    formName={'SearchForm'}
                    numberOfMonths={1}
                  />
                }

              </span>
            </div>
            <div className={cx(s.guests, s.guestPadding, s.mobilePadding, 'tableCellLeftRTL')}>

              <FormControl
                componentClass="select"
                className={cx(s.formControlSelect, s.input, s.inputPadding, 'inputPaddingAR')}
                onChange={(e) => { this.formValue(Number(e.target.value)) }}
                defaultValue={guestCount}
                value={guestCount}
              >
                {rows}
              </FormControl>
            </div>
            <div className={cx(s.search, s.noBroderRight, 'layOut5SearchBtnBottom', 'noBroderRightRTL')}>
              <Button className={cx(bt.btnPrimary, s.btnBlock, s.searchButton, 'layOut5SearchBtn')} onClick={this.handleClick}>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={cx(s.iconStyle)}>
                    <g clipPath="url(#clip0_7_57)">
                      <path d="M15.0173 13.8031L12.2326 11.0184C13.2149 9.72829 13.6703 8.11318 13.5068 6.49994C13.3433 4.8867 12.5731 3.39581 11.352 2.32898C10.1308 1.26215 8.55004 0.699045 6.92946 0.753627C5.30887 0.808209 3.76954 1.4764 2.62296 2.62297C1.47638 3.76955 0.808194 5.30889 0.753612 6.92947C0.69903 8.55006 1.26213 10.1309 2.32896 11.352C3.39579 12.5731 4.88668 13.3434 6.49992 13.5069C8.11317 13.6704 9.72828 13.2149 11.0184 12.2326L13.8031 15.0173C13.9657 15.17 14.1815 15.2534 14.4046 15.2499C14.6276 15.2464 14.8406 15.1562 14.9984 14.9984C15.1562 14.8406 15.2464 14.6277 15.2499 14.4046C15.2534 14.1815 15.17 13.9658 15.0173 13.8031ZM3.86341 10.4566C3.10072 9.6938 2.62612 8.69014 2.52048 7.61663C2.41484 6.54313 2.68469 5.4662 3.28406 4.56936C3.88343 3.67251 4.77522 3.01123 5.80749 2.6982C6.83976 2.38517 7.94864 2.43975 8.94518 2.85264C9.94172 3.26553 10.7643 4.01119 11.2727 4.96256C11.7811 5.91393 11.9439 7.01215 11.7333 8.07009C11.5228 9.12804 10.9519 10.0802 10.118 10.7645C9.28406 11.4487 8.2387 11.8226 7.16 11.8225C5.92363 11.8217 4.73806 11.3305 3.86341 10.4566Z" fill="currentColor" />
                    </g>
                    <defs>
                      <clipPath id="clip0_7_57">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div >
    );
  }
}

SearchForm = reduxForm({
  form: 'HeaderSearchForm', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(SearchForm);

const mapState = (state) => ({
  personalized: state.personalized,
  settingsData: state.viewListing.settingsData,
  listingFields: state.listingFields.data,
  isOneTotalToggle: state.personalized.isOneTotalToggle,
});

const mapDispatch = {
  getSpecificSettings,
  setPersonalizedValues,
  submitForm,
  change,
  changePersonalizedData
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
)(SearchForm);